import { render, staticRenderFns } from "./alarm_sound.vue?vue&type=template&id=34e67f64"
import script from "./alarm_sound.vue?vue&type=script&lang=js"
export * from "./alarm_sound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports